var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.571289,
    y: 0.75,
    width: 50,
    height: 50,
    rx: 8.75,
    fill: "#1AA4DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4639 25.4375V27.0625C41.4639 27.5195 41.0576 27.875 40.6514 27.875H34.3037L31.5107 33.4609C31.2061 34.0703 30.5967 34.4258 29.8857 34.3242C29.2256 34.2734 28.667 33.8164 28.5146 33.1562L25.3662 21.7812L21.9131 37.9805C21.7607 38.6914 21.1006 39.25 20.3896 39.25H20.3389C19.5771 39.25 18.9678 38.793 18.7646 38.082L15.8193 27.875H9.77637C9.31934 27.875 8.96387 27.5195 8.96387 27.1133V25.4375C8.96387 25.0312 9.31934 24.6758 9.77637 24.6758H17.0889C17.7998 24.6758 18.4092 25.1836 18.6123 25.8945L20.085 30.9727L23.5889 14.5703C23.7412 13.8086 24.4014 13.3008 25.1631 13.3008C25.874 13.25 26.585 13.7578 26.7373 14.4688L30.4951 28.2305L31.8662 25.5898C32.1201 24.9805 32.6787 24.625 33.3389 24.625H40.6514C41.0576 24.625 41.4639 25.0312 41.4639 25.4375Z",
    fill: "#82D1EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthData);
export default __webpack_public_path__ + "static/media/healthData.00e20c13.svg";
export { ForwardRef as ReactComponent };